import { css } from '@emotion/css';
import { StyledText } from '@repo/ui/atoms';

export default function DemoMode() {
    return (
        <div
            className={container}
            aria-label="UX Signals widget is in demo mode"
            role="alert"
        >
            <StyledText variant="body" weight="bold">
                Demo
            </StyledText>
        </div>
    );
}

const container = css`
    padding: 14px 16px;
    display: flex;
    border-radius: 99px;
    flex-direction: row;
    background-color: #e9d5ff;
`;
